export const moduleId = 'search';
export const searchSelector = module => module[moduleId];
export const UPDATE_SEARCH_QUERY = 'UPDATE_SEARCH_QUERY';
export const CLEAR_SEARCH_QUERY = 'CLEAR_SEARCH_QUERY';
export const FETCH_AUTOCOMPLETE_RESULTS = 'FETCH_AUTOCOMPLETE_RESULTS';
export const FETCH_AUTO_COMPLETE_RESULTS_SUCCESS =
    'FETCH_AUTO_COMPLETE_RESULTS_SUCCESS';
export const FETCH_AUTO_COMPLETE_RESULTS_FAILURE =
    'FETCH_AUTO_COMPLETE_RESULTS_FAILURE';
export const FETCH_AUTO_COMPLETE_RESULTS_RESET =
    'FETCH_AUTO_COMPLETE_RESULTS_RESET';

export const updateSearchQuery = payload => ({
    payload,
    type: UPDATE_SEARCH_QUERY
});

export const clearSearchQuery = payload => ({
    payload,
    type: CLEAR_SEARCH_QUERY
});

export const fetchAutoCompleteResults = payload => ({
    payload,
    type: FETCH_AUTOCOMPLETE_RESULTS
});

export const fetchAutoCompleteResultsSuccess = payload => ({
    payload,
    type: FETCH_AUTO_COMPLETE_RESULTS_SUCCESS
});

export const fetchAutoCompleteResultsFailure = payload => ({
    payload,
    type: FETCH_AUTO_COMPLETE_RESULTS_FAILURE
});

export const fetchAutoCompleteResultsReset = payload => ({
    payload,
    type: FETCH_AUTO_COMPLETE_RESULTS_RESET
});
